import { render, staticRenderFns } from "./WebHooks.vue?vue&type=template&id=7c022447&scoped=true"
import script from "./WebHooks.vue?vue&type=script&lang=js"
export * from "./WebHooks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c022447",
  null
  
)

export default component.exports